// tslint:disable
import * as React from 'react';
import { Field } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import './checkbox.scss';

declare const $: any;

export interface CheckboxFieldInterface {
    className?: string;
    title?: string;
    property?: string;
    field: Field;
    onChange?: (value: any) => void;
}

export class CheckboxField extends BaseField<CheckboxFieldInterface> {
    public field: Field = this.props.field;
    public state: any = {
        error: null,
        value: false,
    };

    componentDidMount() {
        this.field.registerField();

        $(this.refs[`${this.uid}-checkbox`]).uniform();
        $(this.refs[`${this.uid}-checkbox`]).parent().append('<i class="glyph-icon fa fa-check"></i>');

        $(this.refs[`${this.uid}-checkbox`])
            .parent().parent().parent()
            .on('click', (event: any) => {
                this.handleValueChange(event);
            });

        this.field.onValueChanges$.subscribe((value: any) => {
            this.setViewValue(value);
            if (this.props.onChange) {
                this.props.onChange(value);
            }
        });

        if (this.field.value && this.field.registered) {
            this.setViewValue(this.field.value);
        }

        if (this.field.getValue()){
            $(this.refs[`${this.uid}-checkbox`])
                .parent()
                .addClass("checked");
        }

        // $('.checker span').append('<i class="glyph-icon fa fa-check"></i>');
        // $('.radio span').append('<i class="glyph-icon fa fa-circle"></i>');
    }

    setViewValue(value: boolean) {
        if (value){
            $(`#${this.uid + '_input'}`).parent().addClass('checked');
        } else {
            $(`#${this.uid + '_input'}`).parent().removeClass('checked')
        }
        $(`#${this.uid + '_input'}`).prop('checked', value);
    }

    handleValueChange(event: any) {
        this.setState({
            value: event.target.checked
        });
        this.field.setValue(event.target.checked);
    }

    render() {
        return (
            <div className={this.props.className} id={this.uid}>
                <div className="form-group">
                    <div className="checkbox checkbox-success relative">
                        <label>
                            <input
                                id={this.uid + '_input'}
                                type="checkbox"
                                className="custom-checkbox"
                                ref={`${this.uid}-checkbox`}
                                data-parsley-id="9210"
                                data-parsley-multiple="isFeatured"
                            />
                            {'' || this.props.title || this.field.title}
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/checkbox.field.tsx